export { default } from './Mini';
export type { Props, Props as MiniCourseCardProps } from './Mini';
